import {
  DailySummaryDto,
  TriggerDisplayType,
  TriggerDTO,
} from '@peartherapeutics/hylia-api-client';

export const CRAVING = 'craving';
export const USED = 'used';
export const NOT_USED = 'not-used';
export const NOT_REPORTED = 'not-reported';
export const legends = [CRAVING, USED, NOT_USED, NOT_REPORTED];

export interface ITrigger {
  type: string;
  average: number;
}

const defaultTriggersArray: TriggerDTO[] = [
  { type: 'Angry' as TriggerDisplayType, averageIntensity: 0 },
  { type: 'Hungry' as TriggerDisplayType, averageIntensity: 0 },
  { type: 'Lonely' as TriggerDisplayType, averageIntensity: 0 },
  { type: 'Other' as TriggerDisplayType, averageIntensity: 0 },
  { type: 'Pain' as TriggerDisplayType, averageIntensity: 0 },
  { type: 'Social Pressure' as TriggerDisplayType, averageIntensity: 0 },
  { type: 'Tired' as TriggerDisplayType, averageIntensity: 0 },
];

export const getAverageTriggers = (
  summaries: DailySummaryDto[],
): TriggerDTO[] => {
  const triggersArray = JSON.parse(JSON.stringify(defaultTriggersArray));

  // Key is type, values are: [aggreagate intensity, number of occurrences]
  const triggersMap = new Map([
    ['Angry', [0, 0]],
    ['Hungry', [0, 0]],
    ['Lonely', [0, 0]],
    ['Other', [0, 0]],
    ['Pain', [0, 0]],
    ['Social Pressure', [0, 0]],
    ['Tired', [0, 0]],
  ]);

  // Loop through each daily summary...
  summaries.forEach((summary) => {
    // Loop through each triggers and add to Map
    summary.triggers.forEach((trigger) => {
      let [currentIntensity, count] = [
        triggersMap.get(trigger.type)![0],
        triggersMap.get(trigger.type)![1],
      ];
      const triggerIntensity = trigger.averageIntensity || 0;

      triggersMap.set(trigger.type, [
        currentIntensity + triggerIntensity,
        count + 1,
      ]);
    });
  });

  // Update values
  for (let i = 0; i < triggersArray.length; i++) {
    let [currentIntensity, count] = [
      triggersMap.get(triggersArray[i].type)![0],
      triggersMap.get(triggersArray[i].type)![1],
    ];
    const value = Number((currentIntensity / count).toFixed(1));
    triggersArray[i].averageIntensity = value || 0;
  }
  return triggersArray.sort((a: TriggerDTO, b: TriggerDTO) => {
    if (b.averageIntensity === a.averageIntensity) {
      return Number(b.type) - Number(a.type);
    }
    return Number(b.averageIntensity) - Number(a.averageIntensity);
  });
};

export const getFormattedTriggers = (triggers: TriggerDTO[]) => {
  // Start with zeroed values
  let triggersArray = JSON.parse(JSON.stringify(defaultTriggersArray));

  // Update values
  triggers.forEach((trigger) => {
    let idx = triggersArray.findIndex(
      (a: TriggerDTO) => a.type === trigger.type,
    );
    triggersArray[idx].averageIntensity = trigger.averageIntensity;
  });

  // Sort values
  return triggersArray.sort(
    (a: TriggerDTO, b: TriggerDTO) =>
      Number(b.averageIntensity) - Number(a.averageIntensity),
  );
};
